import { BaseMutationTypes } from '../BaseMutationTypes';

export class DocuSignWorkflowJobMutationTypes extends BaseMutationTypes {
  public static readonly SetIsSignersTabLoading = 'SET_IS_SIGNERS_TAB_LOADING';
  public static readonly SignersTabLoaded = 'SIGNERS_TAB_LOADED';
  public static readonly SignersTabError = 'SIGNERS_TAB_ERROR';
  public static readonly UpdateSignersDataSourceFieldValue = 'UPDATE_SIGNERS_DATA_SOURCE_FIELD_VALUE';
  public static readonly UnloadSignersWorkflowJob = 'UNLOAD_SIGNERS_WORKFLOW_JOB';
}
